<template>
  <div id="autoTransfer" class="auto-transfer" v-if="user != null">
    <SignatureDialog
      @close="isSignPadOpen = false"
      @sign-success="sign($event)"
      v-if="isSignPadOpen"
    />
    <div class="autoTransfer">
      <div class="auto-transfer__top">
        <strong>{{user.store.name}}</strong>(대표자:
        <strong>{{user.name}}</strong>)은(는) P2P플랫폼
        <strong>㈜펀다소셜대부</strong>을(를) 통하여 지원받은 대출금의 상환을 위하여 웰컴페이먼츠 주식회사(이하 ‘페이먼츠’)와 ‘페이먼츠’가
        제휴한 금융기관(이하 ‘제휴 금융기관’)에게 아래의 사실관계에 터잡아 다음과 같이 약정함.
      </div>
      <div class="auto-transfer__content auto-transfer__mx">
        <p class="title">1. 사실관계</p>
        <div class="content-section">
          <p>
            (1)
            <strong>㈜펀다소셜대부</strong> 및
            <strong>㈜펀다소셜대부</strong>와(과) 제휴한 온라인대출정보연계대부업자
            (이하 ‘P2P플랫폼 등’)은(는) 대출금의 원리금(상환금)을 수취 및 보관하기 위하여,
            ‘제휴 금융기관’ 명의의 요구불계좌(이하 ‘A계좌’)를 이용하기로 함.
          </p>
          <p>
            (2)
            <strong>{{user.store.name}}</strong> (대표자:
            <strong>{{user.name}}</strong>)은(는)
            <strong>㈜펀다소셜대부</strong>을(를) 통하여 실행된 대출금을 상환하기 위하여,
            카드결제대금을 수령하는 계좌(이하 ‘B계좌’)에 입금되는 금액을 매 영업일마다 지정된 시각에 ‘A계좌’로 이체하기로 함.
          </p>
        </div>
        <p class="title">2. 의뢰내용</p>
        <div class="content-section">
          (1) 매 영업일
          <strong>11</strong>시
          <strong>30</strong>분마다 ‘B계좌’의 잔액
          전부를 ‘A계좌’로 자동이체 할 것.
        </div>
        <div class="account-section">
          <p class="title">
            A계좌(수납계좌):
            <strong>{{user.repayment_account.holder_name}}</strong>
          </p>
          <div class="account">
            <div>{{user.repayment_account.bank | bankName}}</div>
            <div>{{user.repayment_account.account_number}}</div>
          </div>
        </div>
        <div class="account-section">
          <p class="title">
            B계좌(출금 계좌):
            <strong>{{user.collection_account.holder_name}}</strong>
          </p>
          <div class="account">
            <div>{{user.collection_account.bank | bankName}}</div>
            <div>{{user.collection_account.account_number}}</div>
          </div>
        </div>
        <p class="title">3. 기타</p>
        <div class="content-section">
          <p>
            <strong>{{user.store.name}}</strong>(대표자:
            <strong>{{user.name}}</strong>)은(는) ‘P2P플랫폼 등’ 또는 ‘페이먼츠’를 통하여
            ‘제휴 금융기관’에 본 약정서 및 CMS 출금이체 신청서의 내용이 전달되는 것을 승인함.
          </p>
        </div>
        <div class="sign-section">
          <p class="title">
            {{date.format('YYYY')}}년
            <strong>{{date.format('MM')}}</strong>월
            <strong>{{date.format('DD')}}</strong>일
          </p>
          <p class="title">
            대표자
            <strong>{{user.name}}</strong>
          </p>
          <div v-ripple @click="isSignPadOpen = true" class="sign-box shadow">
            <p v-if="!signImg" class="sign-guide">여기에 사인해주세요!</p>
            <img v-else :src="signImg" />
          </div>
        </div>
      </div>
    </div>
    <div class="section bottom">
      <button
        v-ripple
        :disabled="isLoading || signImg == null"
        class="button next-button"
        type="button"
        @click="agree"
      >
        완료
        <v-progress-circular
          v-if="isLoading"
          style="padding-left: 15px;"
          size="24"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </button>
    </div>
  </div>
</template>
<script>
import SignatureDialog from '@/components/modal/SignatureDialog'
import AuthService from '@/service/auth/AuthService'
import contractsApi from '@/api/now/contractsApi'
import moment from 'moment'

function dataURIToBlob(dataURI) {
  let splitDataURI = dataURI.split(',')
  let byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  let mimeString = splitDataURI[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export default {
  components: {
    SignatureDialog
  },
  async created() {
    this.$store.commit('ui/headerTitle', '자동이체 약정서')
    this.user = AuthService.getProfile()
    this.date = moment()

    try {
      let { data } = await contractsApi.getTerms()
      if (data.length > 0) {
        data.some(term => {
          if (term.code === 'AUTO_TRANSFER') {
            this.transferTerm = term
            return true
          }
        })
        if (this.transferTerm == null) {
          alert('자동이체 약정서가 존재하지 않습니다.')
          this.$router.push({ name: 'documents' })
        } else if (await this.getIsAgreed() === true) {
          alert('이미 동의가 완료된 상태입니다.')
        }
      }
    } catch (e) {
      console.error(e, 'getTerms')
    }
  },
  data() {
    return {
      user: null,
      signImg: null,
      date: null,
      isSignPadOpen: false,
      isAgreed: false,
      isLoading: false
    }
  },
  methods: {
    getIsAgreed() {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await contractsApi.getAgreements()
          let isAgreed = false
          if (data && data.length > 0) {
            data.some(agree => {
              if (agree.term.uuid === this.transferTerm.uuid) {
                isAgreed = agree.is_agreed
                return true
              }
            })
          }
          resolve(isAgreed)
        } catch (e) {
          console.error(e, 'getAgreements')
          reject(e)
        }
      })
    },
    sign(data) {
      this.signImg = data
      this.isSignPadOpen = false
    },
    async agree() {
      if (this.isLoading === true || this.signImg == null) {
        return
      }
      this.isLoading = true

      if (await this.getIsAgreed() === true) {
        alert('이미 동의가 완료된 상태입니다.')
        this.$router.push({ name: 'documents' })
        return
      }

      try {
        let formData = new FormData()
        formData.append('signature', dataURIToBlob(this.signImg), 'signiture.png')
        // formData.append('signature', dataURIToBlob(this.signImg), moment().format('YYYYMMDDHHmmss') + '_signature')
        await contractsApi.postAgreementsAgree(this.transferTerm.uuid, formData)
        this.$router.push({ name: 'documents' })
      } catch (e) {
        console.error(e, 'postAgreementsAgree')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  #autoTransfer {
    height: calc(100vh - 60px);
    .autoTransfer {
      width: 100%;
      height: calc(100% - 68px);
      overflow: auto;
    }
  }
.auto-transfer {
  .shadow {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
  }
  &__mx {
    margin: 0 25px;
  }
  strong {
    font-weight: 900;
  }
  &__top {
    font-size: 16px;
    line-height: 26px;
    background-color: #f4faff;
    padding: 30px 25px;
    margin-bottom: 20px;
  }
  &__content {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 100px;
    .title {
      line-height: 32px;
      font-weight: 700;
    }
    .content-section {
      margin-bottom: 5px;
      p {
        margin-bottom: 6px;
      }
    }
    .account-section {
      .title {
        font-size: 16px;
        line-height: 32px;
        strong {
          font-weight: 900;
        }
      }
      .account {
        display: flex;
        margin-bottom: 11px;
        div {
          text-align: center;
          font-weight: 900;
          padding: 9px;
          background-color: #f4faff;
        }
        div:not(:last-child) {
          margin-right: 10px;
        }
        div:nth-child(1) {
          flex: 1 1 35%;
        }
        div:nth-child(2) {
          flex: 2 2 65%;
        }
      }
    }
    .sign-section {
      margin-top: 20px;
      .title {
        text-align: center;
        line-height: 26px;
      }
      .sign-box {
        height: 18vh;
        margin: 20px 0 30px 0;
        border-radius: 4px;
        .sign-guide {
          line-height: 18vh;
          text-align: center;
          color: #8a94a2;
        }
        img {
          height: calc(18vh - 20px);
          margin: auto;
          display: block;
          padding: 10px 0;
        }
      }
    }
  }
}
</style>
